import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { where } from '@angular/fire/firestore';
import { ActivatedRoute } from '@angular/router';
import { Device } from '@capacitor/device';
import { IonicSlides, PopoverController } from '@ionic/angular';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { PopoverComponent } from 'src/app/components/popover/popover.component';
import { AreaManagementService } from 'src/app/services/area-management/area-management.service';
import { LhFirebaseService } from 'src/app/services/fire/lh-fire.service';

@Component({
    selector: 'app-area-overall-ratings-details',
    templateUrl: './area-overall-ratings-details.page.html',
    styleUrls: ['./area-overall-ratings-details.page.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AreaOverallRatingsDetailsPage extends BaseInjectorService implements OnInit {
  @ViewChild('swiper')
  swiperRef: ElementRef | undefined;
  swiperModules = [IonicSlides];
  pageTitle = this.translate.instant('Welfare and HK review');
  showBackBtn = true;
  headerHeight = '90px';
  defaultUrl = '/house-keeping-review';
  showError=false;
  carouselImages:any[]=[];
  areaSelected: any={};
  averageRatingDetail=[{
    name:'Spillages',
    monthRating:'0.0',
    yearRating:'0'
  },
  {
    name:'Organisations',
    monthRating:'0.0',
    yearRating:'0'
  },
  {
    name:'Shines',
    monthRating:'0.0',
    yearRating:'0'
  }];
 
  commentList:any[]=[];
  loading=true;
  ratingSubmitted: string;
  constructor(private lhFirebaseService: LhFirebaseService,private popoverController:PopoverController,
    private areaService: AreaManagementService,private route: ActivatedRoute,private service: AppService) { 
    super()
  }

  async ngOnInit() {
    if ( this.platform.is('ios') ) {
      const deviceInfo: any = await Device.getInfo();
      const deviceNum=deviceInfo.model.split('iPhone')[1].trim();
      let deviceModel=deviceNum.slice(0, 2);
      if(deviceModel > 10){
        this.headerHeight='110px';
      }else{
        this.headerHeight='90px';
      }
      // this.headerHeight='120px';
    } else if(this.platform.is('android')){
      this.headerHeight='90px';
    }else{
      this.headerHeight='90px';
    }
  }
  async ionViewWillEnter(){
    this.commentList=[];
    this.carouselImages=[];
    this.carouselImages=[];
    
      //+'<br>'+this.areaSelected.area_name+' / '+date;
      let result:any;
      let uniqueResult:any[]=[];
      if(this.ratingSubmitted=='rating'){
        let date= new Date(this.areaSelected.submitted_date).toLocaleDateString('en-GB', {
          month : 'short',
          year : 'numeric'
        }).split(' ').join('-');
        this.areaSelected['shortDate']=date;
        this.pageTitle=this.areaSelected.zone_name;
        result=await this.getRatingSingleRating(this.areaSelected.zone_name,this.areaSelected.area_name,this.areaSelected.submitted_date,this.areaSelected.email); 
        result.forEach(async element => {
          if(element.zone_name==this.areaSelected.zone_name){ 
            uniqueResult.push(element);
          }
        });
        uniqueResult.forEach(async element => {
          await this.getCarouselImages(this.areaSelected.segment,this.areaSelected.locationCategory);
        }); 
      }else{
        let date= new Date(this.areaSelected.submitted_date).toLocaleDateString('en-GB', {
          month : 'short',
          year : 'numeric'
        }).split(' ').join('-');
        this.areaSelected['shortDate']=date;
        this.pageTitle=this.areaSelected.zone_name;
        // if((this.service.appData.userInfo.h_and_s).toLowerCase()=='yes'){
        //   result=await this.getRapidRatingList(this.areaSelected.single_zone,this.areaSelected.area_name,this.areaSelected.submitted_date,this.areaSelected.rapidTourId);
        // }
        // else{
          result=await this.getRatingList(this.areaSelected.zone_name,this.areaSelected.area_name,this.areaSelected.submitted_date);
        // }
        
        result.forEach(async element => {
          if(element.zone_name==this.areaSelected.zone_name){ 
            uniqueResult.push(element);
          }
        });
        uniqueResult.forEach(async element => {
          await this.getCarouselImages(this.areaSelected.segment,this.areaSelected.locationCategory);
        }); 
      }
      
  }
  async getRatingSingleRating(zone:any,area_name:any,submitted_date:any,email){
    let docData:any[]=[];

    let docInfo = await this.lhFirebaseService.queryCollection('area_management_ratings',where("zone_name", '==', zone)
    ,where("area_name", '==', area_name)
    ,where("submitted_date", '==', submitted_date)
    ,where("email",'==',email)
    )
    docInfo.docs?.forEach((doc: any) => {
      docData.push(doc.data());
    })
    let result:any[]=[];
    docData.forEach(element => {
      result.push(element);
    });
    if(result.length>0){
      this.loading=false;
    let spillage=0,cleanlines=0,visuals=0,count=0;
    result.forEach(async element => {
      if(element.category=='Industrial'){
        element.ratings.forEach(data => {
          if (data.name == 'Spillages') {
            spillage = Number(data.rating) + spillage;
          }
          else if (data.name == 'Organisations') {
            cleanlines = Number(data.rating) + cleanlines;
          }
          else if (data.name == 'Shines'){
            visuals = Number(data.rating) + visuals;
          }
        });
      }else{
        element.ratings.forEach(data => {
          if (data.name == 'Cleanliness') {
            spillage = Number(data.rating) + spillage;
          }
          else if (data.name == 'Availability') {
            cleanlines = Number(data.rating) + cleanlines;
          }
          else if (data.name == 'Comfort'){
            visuals = Number(data.rating) + visuals;
          }
        });
      }
      if(element.notes){
        this.commentList.push({name:element.notes})
      }
      count++;
    });
    spillage = (spillage / count);
    cleanlines =(cleanlines / count);
    visuals = (visuals / count);
    if(result[0].category=='Industrial'){
      this.averageRatingDetail[0].name='Spillages';
      this.averageRatingDetail[1].name='Organisations';
      this.averageRatingDetail[2].name='Shines';

    }else{
      this.averageRatingDetail[0].name='Cleanliness';
      this.averageRatingDetail[1].name='Availability';
      this.averageRatingDetail[2].name='Comfort';

    }
    this.averageRatingDetail[0].monthRating=spillage.toFixed(1);
    this.averageRatingDetail[1].monthRating=cleanlines.toFixed(1);
    this.averageRatingDetail[2].monthRating=visuals.toFixed(1);
    }
  return result;
  }
  async getRatingList(zone:any,area_name:any,submitted_date:any){
    let docData:any[]=[];

    let docInfo = await this.lhFirebaseService.queryCollection('area_management_ratings',where("zone_name", '==', zone)
    ,where("area_name", '==', area_name)
    //.where("submitted_date",'==',submitted_date)
    )
    docInfo.docs?.forEach((doc: any) => {
      docData.push(doc.data());
    })
    let result:any[]=[];
    docData.forEach(element => {
      if(new Date(submitted_date).getMonth()===new Date(element.submitted_date).getMonth()){
        result.push(element);
      }
    });
    if(result.length>0){
      this.loading=false;
      let spillage=0,cleanlines=0,visuals=0,count=0;
      result.forEach(async element => {
        if(element.category=='Industrial'){
          element.ratings.forEach(data => {
            if (data.name == 'Spillages') {
              spillage = Number(data.rating) + spillage;
            }
            else if (data.name == 'Organisations') {
              cleanlines = Number(data.rating) + cleanlines;
            }
            else if (data.name == 'Shines'){
              visuals = Number(data.rating) + visuals;
            }
          });
        }else{
          element.ratings.forEach(data => {
            if (data.name == 'Cleanliness') {
              spillage = Number(data.rating) + spillage;
            }
            else if (data.name == 'Availability') {
              cleanlines = Number(data.rating) + cleanlines;
            }
            else if (data.name == 'Comfort'){
              visuals = Number(data.rating) + visuals;
            }
           
          });
        }
        if(element.notes){
          this.commentList.push({name:element.notes})
        }
        count++;
      });
      spillage = (spillage / count);
      cleanlines =(cleanlines / count);
      visuals = (visuals / count);
      if(result[0].category=='Industrial'){
        this.averageRatingDetail[0].name='Spillages';
        this.averageRatingDetail[1].name='Organisations';
        this.averageRatingDetail[2].name='Shines';
  
      }else{
        this.averageRatingDetail[0].name='Cleanliness';
        this.averageRatingDetail[1].name='Availability';
        this.averageRatingDetail[2].name='Comfort';
  
      }
      this.averageRatingDetail[0].monthRating=spillage.toFixed(1);
      this.averageRatingDetail[1].monthRating=cleanlines.toFixed(1);
      this.averageRatingDetail[2].monthRating=visuals.toFixed(1);
    }
   
    return result;
  }

  async getRapidRatingList(zone:any,area_name:any,submitted_date:any,rapidTourId:any){
    let docData:any[]=[];

    let docInfo = await this.lhFirebaseService.queryCollection('area_management_ratings',where("zone_name", '==', zone)
    ,where("area_name", '==', area_name)
    ,where("rapidTourId",'==',rapidTourId)
    )
    docInfo.docs?.forEach((doc: any) => {
      docData.push(doc.data());
    })
    let result:any[]=[];
    docData.forEach(element => {
      if(new Date(submitted_date).getMonth()===new Date(element.submitted_date).getMonth()){
        result.push(element);
      }
    });
    if(result.length>0){
      this.loading=false;
      let spillage=0,cleanlines=0,visuals=0,count=0;
      result.forEach(async element => {
        if(element.category=='Industrial'){
          element.ratings.forEach(data => {
            if (data.name == 'Spillages') {
              spillage = Number(data.rating) + spillage;
            }
            else if (data.name == 'Organisations') {
              cleanlines = Number(data.rating) + cleanlines;
            }
            else if (data.name == 'Shines'){
              visuals = Number(data.rating) + visuals;
            }
          });
        }else{
          element.ratings.forEach(data => {
            if (data.name == 'Cleanliness') {
              spillage = Number(data.rating) + spillage;
            }
            else if (data.name == 'Availability') {
              cleanlines = Number(data.rating) + cleanlines;
            }
            else if (data.name == 'Comfort'){
              visuals = Number(data.rating) + visuals;
            }
           
          });
        }
        if(element.notes){
          this.commentList.push({name:element.notes})
        }
        count++;
      });
      spillage = (spillage / count);
      cleanlines =(cleanlines / count);
      visuals = (visuals / count);
      if(result[0].category=='Industrial'){
        this.averageRatingDetail[0].name='Spillages';
        this.averageRatingDetail[1].name='Organisations';
        this.averageRatingDetail[2].name='Shines';
  
      }else{
        this.averageRatingDetail[0].name='Cleanliness';
        this.averageRatingDetail[1].name='Availability';
        this.averageRatingDetail[2].name='Comfort';
  
      }
      this.averageRatingDetail[0].monthRating=spillage.toFixed(1);
      this.averageRatingDetail[1].monthRating=cleanlines.toFixed(1);
      this.averageRatingDetail[2].monthRating=visuals.toFixed(1);
    }
   
    return result;
  }
  async getCarouselImages(segmentId: string, locationCategoryId: string) {
    let docData: any[] = [];
    
      let docInfo = await this.lhFirebaseService.queryCollection('area_management_segment_images',where("segment", '==', segmentId)
        ,where("location_category", "==", locationCategoryId))
      docInfo.docs?.forEach((doc: any) => {
        docData.push(doc.data());
      });
    if (docData.length > 0) {
      this.carouselImages = docData[0].images;
      this.showError = false;
    } else {
      this.showError = true;
    }
  }
  async infoPopOver(event) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      componentProps: { page: 'AREA_OVERALL_RATING_DETAIL', selection: 'INFO'},
      event: event,
      mode: "ios",
      translucent: true,
      cssClass: "tootip_css",
    });
    await popover.present();
  }
  slidePrev() {
    this.swiperRef?.nativeElement.swiper.slidePrev();
  }
  slideNext() {
    this.swiperRef?.nativeElement.swiper.slideNext()
  }
  dismiss(){
    this.modalController.dismiss();
  }
}
